import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useLocation } from 'react-router-dom';
import { AppHeader } from './Header';
import { Sidebar } from './Sidebar';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  const [mobileOpened, { toggle: toggleMobile, close: closeMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const location = useLocation();
  const isAuthPage = location.pathname === '/login';

  if (isAuthPage) {
    return (
      <AppShell header={{ height: 64 }} padding={0} className="auth-shell">
        <AppHeader
          mobileOpened={false}
          toggleMobile={() => undefined}
          desktopOpened={false}
          toggleDesktop={() => undefined}
          authMode
        />
        <AppShell.Main className="auth-shell__main">{children}</AppShell.Main>
      </AppShell>
    );
  }

  return (
    <AppShell
      header={{ height: 64 }}
      navbar={{
        width: 224,
        breakpoint: 'md',
        collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
      }}
      padding={0}
      className="atlas-shell"
    >
      <AppHeader
        mobileOpened={mobileOpened}
        toggleMobile={toggleMobile}
        desktopOpened={desktopOpened}
        toggleDesktop={toggleDesktop}
      />
      <Sidebar onNavigate={closeMobile} />
      <AppShell.Main className="atlas-main">
        <div className="atlas-content">{children}</div>
      </AppShell.Main>
    </AppShell>
  );
};
